// src/pages/HistoryPage.js
import React from 'react';
import TrialExpiredOverlay from '../components/TrialExpiredOverlay';
import './HistoryPage.css';

function HistoryPage() {
  return (
    <div className="history-page" style={{ position: 'relative', minHeight: '500px' }}>
      <TrialExpiredOverlay section="history" />
      <div className="history-header">
        <h1>History</h1>
        <p>Your reading history and activity</p>
      </div>

      <div className="history-content">
        <div className="history-empty-state">
          <p>History feature coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default HistoryPage;
